define('constants/scheduledReportDeliveryFormatConstants',[], function() {
    return {
        Unknown: "0",
        Csv: "1",
        Pdf: "2"
    };
});
